import { CallAPI } from "../../apiManager/ApiCall";
import {
  webMembersURL,
  webMembersSchemaURL,
} from "../../apiManager/APIConfig";

export const getWebMembersSchemaCall = () =>
  CallAPI({ url: webMembersSchemaURL, method: "GET" });

export const listWebMembersCall = () =>
  CallAPI({ url: webMembersURL, method: "GET" });

export const createWebMemberCall = (body) =>
  CallAPI({ url: webMembersURL, method: "POST", body });

export const updateWebMemberPermissionsCall = (id, body) =>
  CallAPI({
    url: `${webMembersURL}/${id}/permissions`,
    method: "PUT",
    body,
  });

export const updateWebMemberStatusCall = (id, body) =>
  CallAPI({
    url: `${webMembersURL}/${id}/status`,
    method: "PATCH",
    body,
  });

export const deleteWebMemberCall = (id) =>
  CallAPI({ url: `${webMembersURL}/${id}`, method: "DELETE" });
